import { createContext, useContext, useState, useCallback } from 'react';

const MONTH_NAMES = {
  en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
  es: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
};
const DAY_NAMES = {
  en: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
  es: ['Domingo','Lunes','Martes','Mi\u00E9rcoles','Jueves','Viernes','S\u00E1bado'],
};

const translations = {
  en: {
    // Booking Calendar
    reserveYour: 'Reserve Your',
    dayPass: 'Day Pass',
    heroSubtitle: 'Select a time \u00B7 Pay securely \u00B7 Arrive & unwind',
    lookingForTourLink: 'Looking for a guided tour instead?',
    dayPassLabel: 'Day Pass \u2014 Las Ruinas Bathhouse',
    dayPassPrice: '$68 \u00B7 $75.82 with tax',
    dayPassDesc: 'An 11,000 sqft sanctuary in the heart of Old San Juan. Unlimited access to thermal pools, cold plunge, swimming pool, dry sauna, infrared sauna, steam room, complimentary tea lounge, and fully equipped gym. Unlimited towels included.',
    dayPassNote: 'Flip-flops are required \u00B7 Massages Coming Soon \u00B7 Smoothies available as add-ons \u00B7 No re-entry',
    tourHeroLine1: 'Book Your',
    tourHeroLine2: 'Guided Tour',
    tourHeroSubtitle: 'Select a time \u00B7 Free \u00B7 No payment required',
    lookingForDayPassLink: 'Looking to book a day pass instead?',
    tourLabel: 'Guided Tour \u2014 Las Ruinas Bathhouse',
    tourDesc: 'Step inside our 11,000 sqft sanctuary in the heart of Old San Juan before you decide. A brief, informational walkthrough of our thermal pools, cold plunge, swimming pool, dry sauna, infrared sauna, steam room, tea lounge, and gym \u2014 so you can see the space and ask questions in person.',
    tourNote: 'Tours are observational only \u00B7 5\u201310 minutes \u00B7 Booked 24 hours in advance \u00B7 No facility use or access included \u00B7 18+ with valid ID',
    noSlots: 'No time slots available for this date',
    soldOut: 'Sold out',
    lastSpot: 'Last spot',
    left: 'left',
    popular: 'Popular',
    guest: 'guest',
    guests: 'guests',
    guestsLabel: 'Guests',
    reserve: 'Reserve',
    // Footer
    footerCopy: '\u00A9 2026 Las Ruinas Bathhouse & Gym LLC \u00B7 Old San Juan, Puerto Rico',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms & Conditions',
    paymentsSecuredBy: 'Payments secured by Stripe',
    cardOnFileConsent: 'By paying, you agree that Las Ruinas securely saves this card with Stripe and may charge it for booking changes you request, such as upgrades or reschedules.',
    // Checkout
    checkout: 'Checkout',
    orderSummary: 'Order Summary',
    serviceFee: 'Service Fee',
    tax: 'Tax',
    promo: 'Promo',
    total: 'Total',
    contact: 'Contact',
    fullName: 'Full Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    optional: 'optional',
    nameRequired: 'Name is required',
    emailRequired: 'Email is required',
    phoneRequired: 'Phone number is required',
    iAgree: 'I agree to the Las Ruinas',
    iPersonAgree: 'I, {name}, agree to the Las Ruinas',
    andConnector: 'and',
    pleaseAgreeTerms: 'Please agree to the Terms & Conditions to continue',
    cancellationPolicy: 'Cancellation Policy',
    freeCancellation: 'Free cancellation up to 24 hours before your visit',
    noRefund24h: 'No refund within 24 hours of your visit',
    noRefundNoShow: 'No refund for no-shows',
    stripeNonRefundable: 'Stripe processing fee (~3%) is non-refundable on all cancellations. Prices are dynamic and may change based on demand. Your price is locked at time of booking.',
    additionalCostsTitle: 'Additional Costs',
    lockerNote: 'Additional costs such as lockers are subject to availability and have an extra cost.',
    promoCode: 'Promo Code',
    enterCode: 'Enter code',
    apply: 'Apply',
    off: 'off',
    payment: 'Payment',
    processing: 'Processing\u2026',
    pay: 'Pay',
    networkError: 'Network error. Please try again.',
    failedPayment: 'Failed to create payment',
    slotNoLongerAvailable: 'Slot is no longer available. Your payment will be refunded automatically.',
    networkErrorBooking: 'Network error saving your booking. Your payment was successful \u2014 please contact us at Frontdesk@lasruinas.com with ref: ',
    // What's Included
    dayPassTitle: 'Day Pass \u2014 Las Ruinas Bathhouse',
    thermalExperience: 'Your 2.5-hour thermal experience includes:',
    incThermal: 'Thermal pools, cold plunge, hot plunge, swimming pool',
    incSauna: 'Dry sauna, infrared sauna, steam room',
    incTea: 'Complimentary tea lounge',
    incGym: 'Fully equipped gym',
    incTowels: 'Unlimited towels',
    incNote: 'Flip-flops are required. Massages Coming Soon. Smoothies available as add-ons.',
    // Success
    youreConfirmed: "You're confirmed!",
    dayPassBooked: 'Your day pass is booked and ready.',
    sendingEmail: 'Sending confirmation email...',
    emailSent: 'Confirmation email sent',
    emailFailed: 'Email could not be sent',
    viewMyBooking: 'VIEW MY BOOKING',
    // Urgency
    lastAvailableSpot: 'This is the last available spot',
    onlyXSpotsLeft: 'Only {{spots}} spots left',
    onlyXSpotsBook: 'Only {{spots}} spots left \u2014 book now',
    popularSlot: 'One of our most popular time slots',
    // 404
    pageNotFound: 'Page not found',
    pageNotFoundDesc: "The page you're looking for doesn't exist or may have been moved.",
    backToLasRuinas: 'Back to Las Ruinas',
    // Confirmation Page
    confirmationLoading: 'Loading...',
    bookingNotFound: 'Booking not found',
    unableToLoad: 'Unable to load booking. Please check your connection.',
    yourBooking: 'Your Booking',
    bookingConfirmation: 'Booking Confirmation',
    bookingRef: 'Booking Reference',
    date: 'Date',
    time: 'Time',
    amountPaid: 'Amount Paid',
    showQR: 'Show this QR code at the front desk for quick check-in.',
    needToChange: 'Need to change your plans?',
    rescheduleOrCancel: 'RESCHEDULE OR CANCEL',
    // Reschedule Page
    rescheduleBooking: 'Reschedule Your Booking',
    currentBooking: 'Current Booking',
    selectNewSlot: 'Select a new time',
    noAvailableSlots: 'No slots available for this date',
    priceDifference: 'Price Difference',
    samePrice: 'Same price \u2014 no extra charge',
    additionalCharge: 'Additional charge',
    confirmReschedule: 'CONFIRM RESCHEDULE',
    rescheduled: 'Booking Rescheduled!',
    rescheduledSuccess: 'Your booking has been moved to your new time.',
    cancelBooking: 'Cancel Booking',
    cancelConfirmation: 'Are you sure you want to cancel?',
    cancelWarning: 'Cancellations within 24 hours are non-refundable.',
    refundNote: 'A refund (minus Stripe processing fee) will be issued within 5-10 business days.',
    yesCancel: 'YES, CANCEL MY BOOKING',
    neverMind: 'Never mind',
    bookingCancelled: 'Booking Cancelled',
    refundIssued: 'refund will be processed within 5-10 business days.',
    bookNewVisit: 'BOOK A NEW VISIT',
    goToBooking: 'GO TO BOOKING',
    ticketLabel: 'Day Pass',
    // Confirmation Page extras
    guestLabel: 'Guest',
    dateTime: 'Date & Time',
    paymentLabel: 'Payment',
    paid: 'PAID',
    refunded: 'REFUNDED',
    pending: 'PENDING',
    getDirections: 'Get Directions',
    addToCalendar: 'Add to Google Calendar',
    rescheduleOrCancelAction: 'Reschedule or Cancel',
    questions: 'Questions?',
    backToHome: 'Back to Homepage',
    tipTitle: 'Tip:',
    tipText: 'Add this page to your home screen for easy access on arrival',
    // Bundles
    bundlesTabTitle: 'Bundles',
    bundleOffers: 'Bundle Offers',
    noBundleSinglePass: 'No bundle — 1 individual pass',
    passes: 'passes',
    bundleSaveX: 'Save {pct}%',
    bundle: 'Bundle',
    bundlePolicyTitle: 'Bundle Policy',
    bundlePolicy: 'Bundles are valid only for the date of purchase. Passes cannot be carried over to another day, are non-refundable and non-transferable.',
    bundleSameDay: 'All passes valid only on the date of purchase',
    bundleNonCarryover: 'Passes cannot be carried over to another day',
    bundleNonRefundable: 'Non-refundable — no credits for unused passes',
    bundleNonTransferable: 'Non-transferable',
    bundleUpsellTitle: 'Bring friends! Buy {n}+ passes and save {pct}% today',
    bundleUpsellDesc: 'All passes valid for today only.',
    takeOffer: 'Take Offer',
    selectTimeForBundle: 'Select a time slot below to apply this bundle offer',
    // Special Hours (note text is admin-managed per type in config.specialHourTypes)
    specialHoursMoreInfo: 'More information',
    // Tours (free)
    bookATour: 'Book a Tour',
    dayPassBookingTab: 'Day Pass Booking',
    availableTimes: 'Available times',
    tourTimesFree: 'Tour times · free',
    selectTimeToContinue: 'Select a time to continue',
    selectTourTimeToContinue: 'Select a tour time to continue',
    continueLabel: 'Continue',
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    bookPrivateTour: 'Book a private tour',
    bookPrivateTourSub: 'Free guided walk-through of the sanctuary — no payment needed.',
    tourModalTitle: 'Book a Free Tour',
    tourModalSubtitle: 'Choose a date & time · No payment required',
    tourFree: 'Free',
    tourTooSoon: 'Too soon to book',
    tourMaxGuestsHint: 'Maximum {max} people per tour',
    tourSelectDate: 'Select a date',
    tourSelectTime: 'Select a time',
    tourNoSlots: 'No tour times available for this date',
    tourPeopleLabel: 'Number of people',
    tourPerson: 'person',
    tourPeople: 'people',
    confirmTour: 'Confirm Tour',
    tourConfirmTitle: 'Confirm your tour?',
    tourConfirmMessage: "You're booking a tour for {date} at {time} for {count}.",
    tourConfirmYes: 'Confirm',
    tourBookingInProgress: 'Booking your tour…',
    tourConfirmedTitle: 'Your tour is booked!',
    tourConfirmedSubtitle: 'We sent the details to your email.',
    tourRef: 'Tour Reference',
    tourError: 'Something went wrong. Please try again.',
    tourUnavailable: 'Tours are currently unavailable.',
    viewMyTour: 'VIEW MY TOUR',
    tourClose: 'Close',
    // Tour management page
    tourManageTitle: 'Your Tour',
    yourTourDetails: 'Tour Details',
    tourManageReschedule: 'Reschedule Tour',
    tourManageCancel: 'Cancel Tour',
    tourCancelConfirm: 'Are you sure you want to cancel your tour?',
    tourCancelYes: 'YES, CANCEL MY TOUR',
    tourCancelled: 'Tour Cancelled',
    tourCancelledDesc: 'Your tour has been cancelled.',
    tourRescheduledTitle: 'Tour Rescheduled!',
    tourRescheduledSuccess: 'Your tour has been moved to your new time.',
    tourCutoffMessage: 'Changes must be made at least {hours} hours before your tour. Please text us at +1 786-535-8054',
    tourNotFound: 'Tour not found',
    bookAnotherTour: 'BOOK ANOTHER TOUR',
    // VIP Day Pass
    vipCardDesc: 'Full-day access, bathrobe, sandals, and full facility access.',
    vipAccessWindow: 'Access {window}',
    vipReserveCta: 'Reserve VIP',
    vipSoldOutDate: 'Not available for this date',
    vipCheckout: 'VIP Checkout',
    vipDayPassX1: 'VIP Day Pass × 1',
    vipBooked: 'Your VIP Day Pass is booked.',
    vipCancelPolicyFree: 'Free cancellation up to {hours} hours before your VIP day',
    vipCancelPolicyLate: 'No refund within {hours} hours of your VIP day',
    // VIP Day Pass — Reschedule
    vipAccessWindowLabel: 'Access Window',
    vipSelectNewDate: 'Select a new date',
    vipRescheduleDetailsTitle: 'Reschedule Details',
    vipNewDateLabel: 'New Date',
    vipFreeReschedule: 'No additional charge — reschedule is free',
    vipCheaperNoRefund: 'This date is less expensive, but no refund is issued for the price difference.',
    vipOriginalPriceLabel: 'Your original VIP pass was',
    vipNewPriceLabel: 'This VIP day is',
    vipChargeNotice: 'You will be charged {amount} to confirm.',
    vipConfirmWithCharge: 'CONFIRM RESCHEDULE (+{amount})',
    vipPayAndConfirm: 'PAY {amount} & CONFIRM',
    currentBookingPill: 'Current booking',
    vipFreePill: 'Free',
    vipUpgradeBadge: '+{amount} to upgrade',
    confirmationEmailSentTo: 'A confirmation email has been sent to {email}',
    // Complimentary / Influencer bookings (LR-145) — house invitations, never monetary
    compHouseInvitationBadge: "You're our guest",
    compInvitationIntro: 'This visit is on the house — there is nothing to pay.',
    compAccessModeLabel: 'Access',
    compModeAllDay: 'All Day',
    compModeSlot: 'One Time',
    compModeRange: 'Time Range',
    compCancelActionLabel: 'Cancel My Invitation',
    compNoRescheduleNotice: 'This is a complimentary invitation from Las Ruinas — only our team can change the date. You can still cancel below if your plans change.',
    compCancelPolicyLine: "Cancelling frees this date for another guest. Nothing was charged for this visit, so there's nothing to refund.",
    compCancelButtonLabel: 'CANCEL MY INVITATION',
    compYesCancelButton: 'YES, CANCEL MY INVITATION',
    compCancelledTitle: 'Invitation Cancelled',
    compCancelledMessage: 'Your invitation has been cancelled and the space has been freed for another guest.',
    // Language
    langEN: 'EN',
    langES: 'ES',
  },
  es: {
    // Booking Calendar
    reserveYour: 'Reserva Tu',
    dayPass: 'Pase del D\u00EDa',
    heroSubtitle: 'Elige un horario \u00B7 Paga seguro \u00B7 Llega y rel\u00E1jate',
    lookingForTourLink: '\u00BFBuscas un tour guiado?',
    dayPassLabel: 'Pase de D\u00EDa \u2014 Las Ruinas Bathhouse',
    dayPassPrice: '$68 \u00B7 $75.82 con impuesto',
    dayPassDesc: 'Un santuario de 11,000 pies cuadrados en el coraz\u00F3n del Viejo San Juan. Tu pase de 2.5 horas incluye acceso ilimitado a piscinas termales, cold plunge, piscina, sauna seco, sauna infrarrojo, ba\u00F1o de vapor, sal\u00F3n de t\u00E9 gratuito y gimnasio completamente equipado. Toallas ilimitadas incluidas.',
    dayPassNote: 'Chancletas son requeridas \u00B7 Masajes Pr\u00F3ximamente \u00B7 Smoothies disponibles como extras \u00B7 Sin reentrada',
    tourHeroLine1: 'Reserva Tu',
    tourHeroLine2: 'Tour Guiado',
    tourHeroSubtitle: 'Elige un horario \u00B7 Gratis \u00B7 No requiere pago',
    lookingForDayPassLink: '\u00BFBuscas reservar un day pass?',
    tourLabel: 'Tour Guiado \u2014 Las Ruinas Bathhouse',
    tourDesc: 'Entra a nuestro santuario de 11,000 pies cuadrados en el coraz\u00F3n del Viejo San Juan antes de decidir. Un recorrido breve e informativo por nuestras piscinas termales, cold plunge, piscina, sauna seco, sauna infrarrojo, ba\u00F1o de vapor, sal\u00F3n de t\u00E9 y gimnasio \u2014 para que veas el espacio y hagas preguntas en persona.',
    tourNote: 'Los tours son solo observacionales \u00B7 5\u201310 minutos \u00B7 Se reservan con 24 horas de anticipaci\u00F3n \u00B7 No incluye uso ni acceso a las instalaciones \u00B7 18+ con identificaci\u00F3n v\u00E1lida',
    noSlots: 'No hay horarios disponibles para esta fecha',
    soldOut: 'Agotado',
    lastSpot: '\u00DAltimo lugar',
    left: 'disponibles',
    popular: 'Popular',
    guest: 'hu\u00E9sped',
    guests: 'hu\u00E9spedes',
    guestsLabel: 'Hu\u00E9spedes',
    reserve: 'Reservar',
    // Footer
    footerCopy: '\u00A9 2026 Las Ruinas Bathhouse & Gym LLC \u00B7 Viejo San Juan, Puerto Rico',
    privacyPolicy: 'Pol\u00EDtica de Privacidad',
    termsAndConditions: 'T\u00E9rminos y Condiciones',
    paymentsSecuredBy: 'Pagos seguros por Stripe',
    cardOnFileConsent: 'Al pagar, aceptas que Las Ruinas guarde esta tarjeta de forma segura con Stripe y pueda cobrar en ella cambios de reserva que solicites, como mejoras o reprogramaciones.',
    // Checkout
    checkout: 'Pago',
    orderSummary: 'Resumen del Pedido',
    serviceFee: 'Cargo por Servicio',
    tax: 'Impuesto',
    promo: 'Promoci\u00F3n',
    total: 'Total',
    contact: 'Contacto',
    fullName: 'Nombre Completo',
    email: 'Correo Electr\u00F3nico',
    phoneNumber: 'N\u00FAmero de Tel\u00E9fono',
    optional: 'opcional',
    nameRequired: 'El nombre es obligatorio',
    emailRequired: 'El correo es obligatorio',
    phoneRequired: 'El n\u00FAmero de tel\u00E9fono es obligatorio',
    iAgree: 'Acepto los',
    iPersonAgree: 'Yo, {name}, acepto los',
    andConnector: 'y la',
    pleaseAgreeTerms: 'Debes aceptar los T\u00E9rminos y Condiciones para continuar',
    cancellationPolicy: 'Pol\u00EDtica de Cancelaci\u00F3n',
    freeCancellation: 'Cancelaci\u00F3n gratuita hasta 24 horas antes de tu visita',
    noRefund24h: 'Sin reembolso dentro de las 24 horas de tu visita',
    noRefundNoShow: 'Sin reembolso por inasistencia',
    stripeNonRefundable: 'La tarifa de procesamiento de Stripe (~3%) no es reembolsable. Los precios son din\u00E1micos y pueden cambiar seg\u00FAn la demanda. Tu precio se fija al momento de la reserva.',
    additionalCostsTitle: 'Costos Adicionales',
    lockerNote: 'Costos adicionales como los casilleros est\u00E1n sujetos a disponibilidad y tienen un costo extra.',
    promoCode: 'C\u00F3digo Promocional',
    enterCode: 'Ingresa c\u00F3digo',
    apply: 'Aplicar',
    off: 'de descuento',
    payment: 'Pago',
    processing: 'Procesando\u2026',
    pay: 'Pagar',
    networkError: 'Error de red. Intenta de nuevo.',
    failedPayment: 'No se pudo crear el pago',
    slotNoLongerAvailable: 'El horario ya no est\u00E1 disponible. Tu pago ser\u00E1 reembolsado autom\u00E1ticamente.',
    networkErrorBooking: 'Error de red al guardar tu reserva. Tu pago fue exitoso \u2014 cont\u00E1ctanos en Frontdesk@lasruinas.com con ref: ',
    // What's Included
    dayPassTitle: 'Pase del D\u00EDa \u2014 Las Ruinas Bathhouse',
    thermalExperience: 'Tu experiencia termal de 2.5 horas incluye:',
    incThermal: 'Piscinas termales, plunge fr\u00EDo, plunge caliente, piscina',
    incSauna: 'Sauna seco, sauna infrarrojo, ba\u00F1o de vapor',
    incTea: 'Sal\u00F3n de t\u00E9 de cortes\u00EDa',
    incGym: 'Gimnasio totalmente equipado',
    incTowels: 'Toallas ilimitadas',
    incNote: 'Chancletas son requeridas. Masajes Pr\u00F3ximamente. Batidos disponibles como extras.',
    // Success
    youreConfirmed: '\u00A1Est\u00E1s confirmado!',
    dayPassBooked: 'Tu pase del d\u00EDa est\u00E1 reservado y listo.',
    sendingEmail: 'Enviando correo de confirmaci\u00F3n...',
    emailSent: 'Correo de confirmaci\u00F3n enviado',
    emailFailed: 'No se pudo enviar el correo',
    viewMyBooking: 'VER MI RESERVA',
    // Urgency
    lastAvailableSpot: 'Este es el \u00FAltimo lugar disponible',
    onlyXSpotsLeft: 'Solo quedan {{spots}} lugares',
    onlyXSpotsBook: 'Solo quedan {{spots}} lugares \u2014 reserva ahora',
    popularSlot: 'Uno de nuestros horarios m\u00E1s populares',
    // 404
    pageNotFound: 'P\u00E1gina no encontrada',
    pageNotFoundDesc: 'La p\u00E1gina que buscas no existe o fue movida.',
    backToLasRuinas: 'Volver a Las Ruinas',
    // Confirmation Page
    confirmationLoading: 'Cargando...',
    bookingNotFound: 'Reserva no encontrada',
    unableToLoad: 'No se pudo cargar la reserva. Verifica tu conexi\u00F3n.',
    yourBooking: 'Tu Reserva',
    bookingConfirmation: 'Confirmaci\u00F3n de Reserva',
    bookingRef: 'Referencia de Reserva',
    date: 'Fecha',
    time: 'Hora',
    amountPaid: 'Monto Pagado',
    showQR: 'Muestra este c\u00F3digo QR en la recepci\u00F3n para un check-in r\u00E1pido.',
    needToChange: '\u00BFNecesitas cambiar tus planes?',
    rescheduleOrCancel: 'REAGENDAR O CANCELAR',
    // Reschedule Page
    rescheduleBooking: 'Reagendar Tu Reserva',
    currentBooking: 'Reserva Actual',
    selectNewSlot: 'Selecciona un nuevo horario',
    noAvailableSlots: 'No hay horarios disponibles para esta fecha',
    priceDifference: 'Diferencia de Precio',
    samePrice: 'Mismo precio \u2014 sin cargo extra',
    additionalCharge: 'Cargo adicional',
    confirmReschedule: 'CONFIRMAR REAGENDAMIENTO',
    rescheduled: '\u00A1Reserva Reagendada!',
    rescheduledSuccess: 'Tu reserva fue movida a tu nuevo horario.',
    cancelBooking: 'Cancelar Reserva',
    cancelConfirmation: '\u00BFEst\u00E1s seguro de que quieres cancelar?',
    cancelWarning: 'Las cancelaciones dentro de 24 horas no son reembolsables.',
    refundNote: 'El reembolso (menos la tarifa de procesamiento de Stripe) se emitir\u00E1 en 5-10 d\u00EDas h\u00E1biles.',
    yesCancel: 'S\u00CD, CANCELAR MI RESERVA',
    neverMind: 'No importa',
    bookingCancelled: 'Reserva Cancelada',
    refundIssued: 'el reembolso se procesar\u00E1 en 5-10 d\u00EDas h\u00E1biles.',
    bookNewVisit: 'RESERVAR UNA NUEVA VISITA',
    goToBooking: 'IR A LA RESERVA',
    ticketLabel: 'Pase del Día',
    // Confirmation Page extras
    guestLabel: 'Huésped',
    dateTime: 'Fecha y Hora',
    paymentLabel: 'Pago',
    paid: 'PAGADO',
    refunded: 'REEMBOLSADO',
    pending: 'PENDIENTE',
    getDirections: 'Cómo Llegar',
    addToCalendar: 'Agregar a Google Calendar',
    rescheduleOrCancelAction: 'Reagendar o Cancelar',
    questions: '¿Preguntas?',
    backToHome: 'Volver al Inicio',
    tipTitle: 'Consejo:',
    tipText: 'Agrega esta página a tu pantalla de inicio para acceso rápido al llegar',
    // Bundles
    bundlesTabTitle: 'Paquetes',
    bundleOffers: 'Ofertas de Paquetes',
    noBundleSinglePass: 'Sin paquete — 1 pase individual',
    passes: 'pases',
    bundleSaveX: 'Ahorra {pct}%',
    bundle: 'Paquete',
    bundlePolicyTitle: 'Política de Paquetes',
    bundlePolicy: 'Los paquetes son válidos solo en la fecha de compra. Los pases no se pueden trasladar a otro día, no son reembolsables ni transferibles.',
    bundleSameDay: 'Todos los pases son válidos solo en la fecha de compra',
    bundleNonCarryover: 'Los pases no se pueden trasladar a otro día',
    bundleNonRefundable: 'No reembolsables — sin crédito por pases no usados',
    bundleNonTransferable: 'No transferibles',
    bundleUpsellTitle: '¡Trae amigos! Compra {n}+ pases y ahorra {pct}% hoy',
    bundleUpsellDesc: 'Todos los pases válidos solo para hoy.',
    takeOffer: 'Aprovechar Oferta',
    selectTimeForBundle: 'Selecciona un horario abajo para aplicar esta oferta de bundle',
    // Special Hours (note text is admin-managed per type in config.specialHourTypes)
    specialHoursMoreInfo: 'Más información',
    // Tours (free)
    bookATour: 'Reservar un Tour',
    dayPassBookingTab: 'Reserva de Pase',
    availableTimes: 'Horarios disponibles',
    tourTimesFree: 'Horarios de tour · gratis',
    selectTimeToContinue: 'Elige un horario para continuar',
    selectTourTimeToContinue: 'Elige un horario de tour para continuar',
    continueLabel: 'Continuar',
    prevMonth: 'Mes anterior',
    nextMonth: 'Mes siguiente',
    bookPrivateTour: 'Reserva un tour privado',
    bookPrivateTourSub: 'Recorrido guiado gratuito del santuario — sin pago requerido.',
    tourModalTitle: 'Reserva un Tour Gratis',
    tourModalSubtitle: 'Elige fecha y hora · Sin pago requerido',
    tourFree: 'Gratis',
    tourTooSoon: 'Muy pronto para reservar',
    tourMaxGuestsHint: 'Máximo {max} personas por tour',
    tourSelectDate: 'Selecciona una fecha',
    tourSelectTime: 'Selecciona un horario',
    tourNoSlots: 'No hay tours disponibles para esta fecha',
    tourPeopleLabel: 'Número de personas',
    tourPerson: 'persona',
    tourPeople: 'personas',
    confirmTour: 'Confirmar Tour',
    tourConfirmTitle: '¿Confirmar tu tour?',
    tourConfirmMessage: 'Vas a reservar un tour para {date} a las {time} para {count}.',
    tourConfirmYes: 'Confirmar',
    tourBookingInProgress: 'Reservando tu tour…',
    tourConfirmedTitle: '¡Tu tour está reservado!',
    tourConfirmedSubtitle: 'Enviamos los detalles a tu correo.',
    tourRef: 'Referencia del Tour',
    tourError: 'Algo salió mal. Intenta de nuevo.',
    tourUnavailable: 'Los tours no están disponibles por ahora.',
    viewMyTour: 'VER MI TOUR',
    tourClose: 'Cerrar',
    // Tour management page
    tourManageTitle: 'Tu Tour',
    yourTourDetails: 'Detalles del Tour',
    tourManageReschedule: 'Reagendar Tour',
    tourManageCancel: 'Cancelar Tour',
    tourCancelConfirm: '¿Seguro que quieres cancelar tu tour?',
    tourCancelYes: 'SÍ, CANCELAR MI TOUR',
    tourCancelled: 'Tour Cancelado',
    tourCancelledDesc: 'Tu tour ha sido cancelado.',
    tourRescheduledTitle: '¡Tour Reagendado!',
    tourRescheduledSuccess: 'Tu tour fue movido a tu nuevo horario.',
    tourCutoffMessage: 'Los cambios deben hacerse al menos {hours} horas antes de tu tour. Escríbenos al +1 786-535-8054',
    tourNotFound: 'Tour no encontrado',
    bookAnotherTour: 'RESERVAR OTRO TOUR',
    // VIP Day Pass
    vipCardDesc: 'Acceso de día completo, bata, sandalias y acceso completo a las instalaciones.',
    vipAccessWindow: 'Acceso {window}',
    vipReserveCta: 'Reservar VIP',
    vipSoldOutDate: 'No disponible para esta fecha',
    vipCheckout: 'Pago VIP',
    vipDayPassX1: 'VIP Day Pass × 1',
    vipBooked: 'Tu VIP Day Pass está reservado.',
    vipCancelPolicyFree: 'Cancelación gratuita hasta {hours} horas antes de tu día VIP',
    vipCancelPolicyLate: 'Sin reembolso dentro de {hours} horas de tu día VIP',
    // VIP Day Pass — Reschedule
    vipAccessWindowLabel: 'Horario de Acceso',
    vipSelectNewDate: 'Selecciona una nueva fecha',
    vipRescheduleDetailsTitle: 'Detalles del Reagendamiento',
    vipNewDateLabel: 'Nueva Fecha',
    vipFreeReschedule: 'Sin cargo adicional — reagendar es gratis',
    vipCheaperNoRefund: 'Esta fecha es más económica, pero no se emite ningún reembolso por la diferencia de precio.',
    vipOriginalPriceLabel: 'Tu pase VIP original costaba',
    vipNewPriceLabel: 'Este día VIP cuesta',
    vipChargeNotice: 'Se te cobrará {amount} para confirmar.',
    vipConfirmWithCharge: 'CONFIRMAR REAGENDAMIENTO (+{amount})',
    vipPayAndConfirm: 'PAGAR {amount} Y CONFIRMAR',
    currentBookingPill: 'Reserva actual',
    vipFreePill: 'Gratis',
    vipUpgradeBadge: '+{amount} para mejorar',
    confirmationEmailSentTo: 'Se ha enviado un correo de confirmación a {email}',
    // Complimentary / Influencer bookings (LR-145) — invitaciones de la casa, nunca monetario
    compHouseInvitationBadge: 'Eres nuestro invitado',
    compInvitationIntro: 'Esta visita es cortesía de la casa — no hay nada que pagar.',
    compAccessModeLabel: 'Acceso',
    compModeAllDay: 'Todo el Día',
    compModeSlot: 'Una Vez',
    compModeRange: 'Rango de Horario',
    compCancelActionLabel: 'Cancelar Mi Invitación',
    compNoRescheduleNotice: 'Esta es una invitación de cortesía de Las Ruinas — solo nuestro equipo puede cambiar la fecha. Aún puedes cancelar abajo si tus planes cambian.',
    compCancelPolicyLine: 'Cancelar libera esta fecha para otro invitado. No se cobró nada por esta visita, así que no hay ningún reembolso.',
    compCancelButtonLabel: 'CANCELAR MI INVITACIÓN',
    compYesCancelButton: 'SÍ, CANCELAR MI INVITACIÓN',
    compCancelledTitle: 'Invitación Cancelada',
    compCancelledMessage: 'Tu invitación ha sido cancelada y el espacio ha sido liberado para otro invitado.',
    // Language
    langEN: 'EN',
    langES: 'ES',
  },
};

export function tRaw(lang, key) {
  return (translations[lang] && translations[lang][key]) || translations.en[key] || '';
}

const LangContext = createContext({ lang: 'en', t: (k) => k, setLang: () => {}, monthNames: MONTH_NAMES.en, dayNames: DAY_NAMES.en });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem('lr_lang');
      if (saved) return saved;
      const detected = (navigator.language || '').startsWith('es') ? 'es' : 'en';
      localStorage.setItem('lr_lang', detected);
      return detected;
    } catch { return 'en'; }
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem('lr_lang', l); } catch {}
  }, []);

  const t = useCallback((key, replacements) => {
    let str = (translations[lang] && translations[lang][key]) || translations.en[key] || key;
    if (replacements) {
      Object.entries(replacements).forEach(([k, v]) => {
        str = str.replace(`{${k}}`, v).replace(`{{${k}}}`, v);
      });
    }
    return str;
  }, [lang]);

  const monthNames = MONTH_NAMES[lang] || MONTH_NAMES.en;
  const dayNames = DAY_NAMES[lang] || DAY_NAMES.en;

  return (
    <LangContext.Provider value={{ lang, setLang, t, monthNames, dayNames }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

export function LanguageToggle() {
  const { lang, setLang } = useLang();
  return (
    <div className="lr-lang-toggle" data-testid="language-toggle">
      <button
        className={`lr-lang-btn${lang === 'en' ? ' active' : ''}`}
        data-testid="lang-en"
        onClick={() => setLang('en')}
      >EN</button>
      <button
        className={`lr-lang-btn${lang === 'es' ? ' active' : ''}`}
        data-testid="lang-es"
        onClick={() => setLang('es')}
      >ES</button>
    </div>
  );
}
